import {
    INotificationProperties,
    createNotification,
} from '@vfde-brix/ws10/notification';
import { NO_PATTERN_BUSINESS_LOGIC } from '@vfde-brix/ws10/core';
import { mountComponent } from '../util/mount';
import { HtmlId } from '../enums/elementId';

/**
 * Create Brix Notification component.
 *
 * @param id - Wrapper ID of the element.
 * @param props - Brix Notification properties.
 * @returns Notification component
 * or null if the element with the given ID is not found.
 */
export const mountNotification = (id: HtmlId, props?: INotificationProperties) =>
    mountComponent(id, createNotification, props || NO_PATTERN_BUSINESS_LOGIC);
